module.exports = __webpack_public_path__ + "img/negative.5b5357d0.png";